import BreadcrumbEvent from "components/Common/BreadcrumbEvent"
import EventNavbar from "components/CommonForBoth/EventNavbar"
import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Button, Card, Col, Container, Row } from "reactstrap"
import { Helmet } from "react-helmet-async"

const EventsDetail = () => {
  const [eventData, setEventData] = useState(null)
  const { url } = useParams()

  console.log("EventsDetail url", url)
  useEffect(() => {
    if (!url) return
    // Fetch event by slug
    fetch(`${process.env.REACT_APP_API_URL}/dashboard/get-event-details/${url}`)
      .then(res => res.json())
      .then(data => setEventData(data.event))
      .catch(err => console.error("Failed to fetch event data", err))
  }, [url])

  // Safe parse for schedules
  let schedules = []
  /*  if (eventData?.schedules) {
    try {
      if (typeof eventData.schedules == "string") {
        schedules = JSON.parse(eventData.schedules)
        console.log("eventData.schedules",  schedules)
      } else if (Array.isArray(eventData.schedules)) {
        schedules = eventData.schedules
      }
    } catch (e) {
      schedules = []
    }
  } */
  if (eventData?.schedules) {
    try {
      if (typeof eventData.schedules === "string") {
        // Replace single quotes with double quotes to make it valid JSON
        const fixedString = eventData.schedules.replace(/'/g, '"')
        schedules = JSON.parse(fixedString)
        console.log("eventData.schedules", schedules)
      } else if (Array.isArray(eventData.schedules)) {
        schedules = eventData.schedules
      }
    } catch (e) {
      console.error("Failed to parse schedules:", e)
      schedules = []
    }
  }

  function formatEventTime(timeStr) {
    // Converts "12:00PM" or "04:00PM" to "12PM" or "4PM"
    if (!timeStr) return ""
    const match = timeStr.match(/^(\d{1,2}):?(\d{2})?(AM|PM)$/i)
    if (!match) return timeStr
    let hour = parseInt(match[1], 10)
    const period = match[3].toUpperCase()
    return `${hour}${period}`
  }
  console.log("eventData", eventData)
  return (
    <>
      <Helmet>
        <title>{"PULA Networking Meet | Book Your Pass Now"}</title>
        <meta
          name="description"
          content={
            "The PULA Business Networking Meet is an exclusive platform for women entrepreneurs and professionals to connect, collaborate, and grow together. Limited seats – book your pass today!"
          }
        />
        {/* Open Graph Metadata */}
        <meta property="og:title" content="PULA Networking Meet" />
        <meta
          property="og:description"
          content="The PULA Business Networking Meet is an exclusive platform for women entrepreneurs and professionals to connect, collaborate, and grow together."
        />
        <meta
          property="og:image"
          content={
            eventData?.banner
              ? `${process.env.REACT_APP_API_URL.replace("/api", "")}/storage/${
                  eventData.banner
                }`
              : `${process.env.REACT_APP_URL}/logo512.png/`
          }
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_URL}/event-details/${url}`}
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <EventNavbar />
      <Container fluid={false} className="pt-4">
        <BreadcrumbEvent
          title="Events"
          toTitle="/"
          breadcrumbItem="Event Details"
        />
      </Container>
      <section id="events-detail" className="py-4">
        <Container fluid={false}>
          <div className="events-detail">
            <Card>
              <img
                src={`${process.env.REACT_APP_API_URL.replace(
                  "/api",
                  ""
                )}/storage/${eventData?.banner}`}
                className="img-fluid eventdetail-img"
                alt="Event Details Page"
              />
            </Card>

            <div className="event-detail-content text-center pt-4 mb-4">
              <h1 className="event-title text-primary">{eventData?.title}</h1>
            </div>

            <Row className="ed-card-box py-3">
              <Col sm={12} md={6}>
                <Card className="bg-white innerbox-one-cardone p-4 h-100 mb-0">
                  <div className="event-detail-description">
                    {/* <h2 className="text-primary h3 mb-4">Event About</h2> */}

                    <p className="mt-1 mb-2 text-black font-size-16">
                      <div
                        className="music-criteria"
                        dangerouslySetInnerHTML={{
                          __html: eventData?.description_about,
                        }}
                      />
                    </p>

                    {eventData?.description_iternary && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Itinerary: </b>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: eventData?.description_iternary,
                          }}
                        />
                      </p>
                    )}
                  </div>
                </Card>
              </Col>
              <Col sm={12} md={6} className="d-grid gap-4">
                <Card className="innerbox-two-cardone p-4 mb-0">
                  <div className="event-detail-description">
                    <h2 className="text-primary h3 mb-2">Event Schedule</h2>
                    {schedules.length > 0 ? (
                      schedules.map((sch, idx) => (
                        <div key={idx}>
                          <p className="mb-2 text-black font-size-16">
                            <b>Event Date:</b>{" "}
                            {(() => {
                              const d = new Date(sch.date)
                              const day = d.getDate()
                              const suffix = ["th", "st", "nd", "rd"][
                                day % 10 < 4 && Math.floor(day / 10) !== 1
                                  ? day % 10
                                  : 0
                              ]
                              const month = d.toLocaleDateString("en-GB", {
                                month: "long",
                              })
                              const weekday = d.toLocaleDateString("en-GB", {
                                weekday: "long",
                              })
                              return `${day}${suffix} ${month}, ${weekday}`
                            })()}
                          </p>
                          {/*  <p className="mt-1 mb-2 text-black font-size-16">
                            <b>Start Time:</b> {sch.start}
                          </p>
                          <p className="mt-1 mb-0 text-black font-size-16">
                            <b>End Time:</b> {sch.end}
                          </p> */}
                          <p className="mt-1 mb-2 text-black font-size-16">
                            <b>Event Time:</b>{" "}
                            {`${formatEventTime(
                              sch.start
                            )} to ${formatEventTime(sch.end)}`}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p className="mb-2 text-black font-size-16">
                        No schedule available
                      </p>
                    )}
                  </div>
                  <div className="event-detail-description ">
                    <h2 className="text-primary h3 mb-2">Location</h2>
                    {eventData?.location && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Location: </b>
                        <span>{eventData.location}</span>
                      </p>
                    )}
                    {eventData?.address && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Address: </b>
                        <span>{eventData.address}</span>
                      </p>
                    )}
                    {eventData?.landmark && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Landmark: </b>
                        <span>{eventData.landmark}</span>
                      </p>
                    )}
                    {eventData?.google_address && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Google Map: </b>
                        <a
                          href={eventData.google_address}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ wordBreak: "break-all" }}
                        >
                          {eventData.google_address}
                        </a>
                      </p>
                    )}
                    {!eventData?.location &&
                      !eventData?.address &&
                      !eventData?.landmark &&
                      !eventData?.google_address && (
                        <p className="mt-1 mb-2 text-black font-size-16">
                          <b>No location details available</b>
                        </p>
                      )}
                  </div>
                  <div className="event-detail-description ">
                    <h2 className="text-primary h3 mb-2">Charges</h2>
                    {eventData?.tickets && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        {eventData?.tickets?.map((ticket, idx) => {
                          const priceIncl = Number(ticket.cost) // e.g. 1180 (₹) ➜ inclusive
                          const priceExcl = +(priceIncl / 1.18).toFixed(2) // base cost = inclusive ÷ 1.18
                          const gst = +(priceIncl - priceExcl).toFixed(2) // GST portion

                          return (
                            <span key={idx}>
                              INR&nbsp;{priceExcl.toLocaleString("en-IN")}
                               + 18% GST
                              <br />
                              {/* Alcohol&nbsp;available&nbsp;on&nbsp;Cash&nbsp;&amp;&nbsp;Carry */}
                            </span>
                          )
                        })}
                      </p>
                    )}
                  </div>
                  <div className="event-detail-description ">
                    <h2 className="text-primary h3 mb-2">Dress Code</h2>
                    {eventData?.tickets && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        {/* Black & Gold (Western Wear) */}
                        India or Western Smart Business outfits or Sarees
                      </p>
                    )}
                  </div>
                </Card>
                {/*    <Card className="innerbox-two-cardtwo p-4 mb-0">
                  <div className="event-detail-description">
                    <h2 className="text-primary h3 mb-4">Other Details</h2>

                    {eventData?.description_inclusions && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Inclusions: </b>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: eventData?.description_inclusions,
                          }}
                        />
                      </p>
                    )}
                    {eventData?.description_exclusions && (
                      <p className="mt-1 mb-2 text-black font-size-16">
                        <b>Exclusions: </b>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: eventData?.description_exclusions,
                          }}
                        />
                      </p>
                    )}
                  </div>
                </Card> */}
              </Col>
            </Row>
            <Row>
              {!eventData?.sold_out && (
                <Col md={12} className="text-center mt-4">
                  <Link to={`/book/${url}`}>
                    <Button className="btn btn-primary px-5 py-2 font-size-16 bg-primary text-white btn-md">
                      Book Now
                    </Button>
                  </Link>
                </Col>
              )}
            </Row>
          </div>
        </Container>
      </section>
    </>
  )
}

export default EventsDetail
